import { zeroQuotaIsCap } from "../../supabase/functions/_shared/credits-plan";

export interface NextWorkspaceFreeQuota {
  includesFreeQuota: boolean;
  holderName: string | null;
}

export function parseNextWorkspaceFreeQuota(raw: unknown): NextWorkspaceFreeQuota | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const value = raw as Record<string, unknown>;
  if (typeof value.includes_free_quota !== "boolean") return null;
  const holderName = typeof value.holder_name === "string" && value.holder_name.trim() ? value.holder_name.trim() : null;
  return { includesFreeQuota: value.includes_free_quota, holderName };
}

export function noFreeQuotaWarning(holderName: string | null): string {
  const where = holderName ? `en «${holderName}»` : "en otro espacio de trabajo";
  return `Este workspace no incluirá conversaciones gratis: tu plan Explora gratis ya está ${where}. La IA del nuevo workspace no responderá hasta que elijas un plan pago.`;
}

export interface WithheldQuota {
  conversations_used: number | null;
  conversations_limit?: number | null;
  conversations_extra?: number | null;
  free_quota_withheld?: boolean | null;
  plan?: string | null;
}

export function withheldConversationCap(quota: WithheldQuota): number {
  return Math.max(0, Number(quota.conversations_limit ?? 0)) + Math.max(0, Number(quota.conversations_extra ?? 0));
}

export function isOverWithheldCap(quota: WithheldQuota | null | undefined): boolean {
  if (!quota || !zeroQuotaIsCap(quota)) return false;
  return Number(quota.conversations_used ?? 0) > withheldConversationCap(quota);
}
